import React from 'react';
import { CustomColumn } from 'baseui/data-table';
import _isNaN from 'lodash/isNaN';
import _some from 'lodash/some';
import _toLower from 'lodash/toLower';
import dayjs from 'dayjs';
import { EMPTY_STRING } from 'commons-ui';

interface ICustomDateColumn {
	title: any;
	minWidth?: any;
	maxWidth?: any;
	columnName: any;
	format?: string;
}

const normalize = (str: string) => _toLower(str);

const includesValue = (val: string, obj: object) => {
	const search = normalize(val);
	return _some(obj, (v) => normalize(v).includes(search));
};

const formattedTime = (value: any, format?: string) => {
	return value && !_isNaN(value)
		? dayjs(new Date(value))
				.format(format || 'MMM D, YYYY h:mm A')
				.toString()
		: EMPTY_STRING;
};

const CustomDateColumn: React.FC<ICustomDateColumn> = (props) => {
	const { title, minWidth = 200, maxWidth = 200, columnName, format } = props;
	return CustomColumn({
		title,
		minWidth,
		maxWidth,
		mapDataToValue: (data: any) => data[columnName],
		renderCell: (params: any) => {
			const { value } = params;
			return <div>{formattedTime(value, format)}</div>;
		},
		sortable: true,
		sortFn: (dateA: number, dateB: number): number => {
			if (!dateA) {
				return -1;
			}
			if (!dateB) {
				return 1;
			}
			return dateA < dateB ? 1 : -1;
		},
		textQueryFilter: (textQuery: string, data: any): boolean => {
			return includesValue(`${textQuery}`, { timeStamp: formattedTime(data, format) });
		}
	});
};
export default CustomDateColumn;
